module.exports = __webpack_public_path__ + "img/icon_landing3.7cf2466b.jpeg";